/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum PolicyType {
    VIEW_ORDERS = 'ViewOrders',
    VIEW_LIVE_ORDERS = 'ViewLiveOrders',
    CANCEL_ORDERS = 'CancelOrders',
    MANAGE_ORDERS = 'ManageOrders',
    MANAGE_ORDER_ADMIN_NOTES = 'ManageOrderAdminNotes',
    VIEW_ORDER_ADMIN_NOTES = 'ViewOrderAdminNotes',
    DELETE_ORDER_ADMIN_NOTES = 'DeleteOrderAdminNotes',
    VIEW_USER_ORDER_RATES = 'ViewUserOrderRates',
    MANAGE_CANCEL_ORDER_REASONS = 'ManageCancelOrderReasons',
    VIEW_CANCEL_ORDER_REASONS = 'ViewCancelOrderReasons',
    DELETE_CANCEL_ORDER_REASONS = 'DeleteCancelOrderReasons',
    MANAGE_CANCEL_MEAL_REASONS = 'ManageCancelMealReasons',
    VIEW_CANCEL_MEAL_REASONS = 'ViewCancelMealReasons',
    DELETE_CANCEL_MEAL_REASONS = 'DeleteCancelMealReasons',
    MANAGE_CANCEL_PACKAGE_REASONS = 'ManageCancelPackageReasons',
    VIEW_CANCEL_PACKAGE_REASONS = 'ViewCancelPackageReasons',
    DELETE_CANCEL_PACKAGE_REASONS = 'DeleteCancelPackageReasons',
    MANAGE_USER_ORDER_RATE_REASONS = 'ManageUserOrderRateReasons',
    VIEW_USER_ORDER_RATE_REASONS = 'ViewUserOrderRateReasons',
    DELETE_USER_ORDER_RATE_REASONS = 'DeleteUserOrderRateReasons',
    VIEW_ORDER_DETAILS = 'ViewOrderDetails',
    RE_CALCULATE_DRIVER_EARNINGS = 'ReCalculateDriverEarnings',
    CHANGE_ORDER_STATUS_WHEN_IS_ACTIVE = 'ChangeOrderStatusWhenIsActive',
    ASSIGN_ORDER_TO_DRIVER = 'AssignOrderToDriver',
    ACQUIRE_ORDER_TO_DRIVER = 'AcquireOrderToDriver',
    CHANGE_ORDER_STATUS_WHEN_IS_NOT_ACTIVE = 'ChangeOrderStatusWhenIsNotActive',
    MANAGE_CUSTOMER_NOTES = 'ManageCustomerNotes',
    VIEW_CUSTOMER_NOTES = 'ViewCustomerNotes',
    DELETE_CUSTOMER_NOTES = 'DeleteCustomerNotes',
    MANAGE_ORDER_NOTE = 'ManageOrderNote',
    VIEW_ORDER_NOTES = 'ViewOrderNotes',
    DELETE_ORDER_NOTE = 'DeleteOrderNote',
    UPDATE_ORDER_DEDUCTION_WHEN_IT_IS_ACTIVE = 'UpdateOrderDeductionWhenItIsActive',
    UPDATE_ORDER_DEDUCTION_WHEN_IS_NOT_ACTIVE = 'UpdateOrderDeductionWhenIsNotActive',
    UPDATE_ORDER_ITEMS_WHEN_IT_IS_ACTIVE = 'UpdateOrderItemsWhenItIsActive',
    UPDATE_ORDER_ITEMS_WHEN_IS_NOT_ACTIVE = 'UpdateOrderItemsWhenIsNotActive',
    VIEW_SHIPMENTS = 'ViewShipments',
    MANAGE_SHIPMENTS = 'ManageShipments',
    CANCEL_SHIPMENTS = 'CancelShipments',
    TRANSFER_SHIPMENTS = 'TransferShipments',
    VIEW_TRACKING_PAGE = 'ViewTrackingPage',
    VIEW_JOBS = 'ViewJobs',
    VIEW_MONITORING = 'ViewMonitoring',
    VIEW_GROUPS = 'ViewGroups',
    MANAGE_CANCEL_SHIPMENT_REASONS = 'ManageCancelShipmentReasons',
    VIEW_CANCEL_SHIPMENT_REASONS = 'ViewCancelShipmentReasons',
    DELETE_CANCEL_SHIPMENT_REASONS = 'DeleteCancelShipmentReasons',
    MANAGE_ITEMS = 'ManageItems',
    VIEW_ITEMS = 'ViewItems',
    VIEW_ITEM_DETAILS = 'ViewItemDetails',
    DELETE_ITEMS = 'DeleteItems',
    VIEW_SELECTIONS = 'ViewSelections',
    MANAGE_SELECTIONS = 'ManageSelections',
    DELETE_SELECTIONS = 'DeleteSelections',
    VIEW_ITEM_UNIT_DETAILS = 'ViewItemUnitDetails',
    VIEW_ITEM_UNITS = 'ViewItemUnits',
    MANAGE_ITEM_UNITS = 'ManageItemUnits',
    DELETE_ITEM_UNITS = 'DeleteItemUnits',
    VIEW_CATEGORIES = 'ViewCategories',
    VIEW_CATEGORY_DETAILS = 'ViewCategoryDetails',
    MANAGE_CATEGORIES = 'ManageCategories',
    DELETE_CATEGORIES = 'DeleteCategories',
    VIEW_BRANCHES = 'ViewBranches',
    VIEW_BRANCH_DETAILS = 'ViewBranchDetails',
    MANAGE_BRANCHES = 'ManageBranches',
    DELETE_BRANCHES = 'DeleteBranches',
    MANAGE_BRANCH_VIP = 'ManageBranchVip',
    MANAGE_BRANCH_INTERFACE_TYPE = 'ManageBranchInterfaceType',
    MANAGE_BRANCH_CHANNEL = 'ManageBranchChannel',
    MANAGE_BRANCH_SERVICE = 'ManageBranchService',
    MANAGE_BRANCH_BRAND = 'ManageBranchBrand',
    MANAGE_BRANCH_FULFILLMENT_TYPE = 'ManageBranchFulfillmentType',
    MANAGE_BRANCH_SALES_MAN = 'ManageBranchSalesMan',
    MANAGE_BRANCH_BRANCH_DELIVERY_SYSTEM = 'ManageBranchBranchDeliverySystem',
    MANAGE_BRANCH_MINIMUM_CART_AMOUNT_TO_ORDER = 'ManageBranchMinimumCartAmountToOrder',
    MANAGE_BRANCH_SKU_PREFIX = 'ManageBranchSkuPrefix',
    MANAGE_BRANCH_AUTO_ORDER_APPROVAL_PRICE_LIMIT = 'ManageBranchAutoOrderApprovalPriceLimit',
    MANAGE_BRANCH_TAX_RATIO_PER_ORDER = 'ManageBranchTaxRatioPerOrder',
    MANAGE_BRANCH_COMMISSION_AMOUNT_PER_ORDER = 'ManageBranchCommissionAmountPerOrder',
    MANAGE_BRANCH_TRANSLATIONS = 'ManageBranchTranslations',
    MANAGE_BRANCH_LOCATION = 'ManageBranchLocation',
    MANAGE_BRANCH_CONTACTS = 'ManageBranchContacts',
    VIEW_BRANCH_SHIFTS = 'ViewBranchShifts',
    MANAGE_BRANCH_SHIFTS = 'ManageBranchShifts',
    MANAGE_BRANCH_ZOHO_VALUES = 'ManageBranchZohoValues',
    MANAGE_BRANCH_DISTRICTS = 'ManageBranchDistricts',
    MANAGE_BRANCH_BRANCH_TAGS = 'ManageBranchBranchTags',
    IMPORT_BRANCH_FILES = 'ImportBranchFiles',
    EXPORT_BRANCH_FILES = 'ExportBranchFiles',
    EXPORT_BRANCH_USERS = 'ExportBranchUsers',
    VIEW_BRANCH_STATUS_LOGS = 'ViewBranchStatusLogs',
    VIEW_BRANCH_DELIVERY_DISCOUNT = 'ViewBranchDeliveryDiscount',
    DELETE_BRANCH_DELIVERY_DISCOUNT = 'DeleteBranchDeliveryDiscount',
    MANAGE_BRANCH_DELIVERY_DISCOUNT = 'ManageBranchDeliveryDiscount',
    VIEW_CHANNELS = 'ViewChannels',
    VIEW_CHANNEL_DETAILS = 'ViewChannelDetails',
    VIEW_CHANNEL_LAYOUT = 'ViewChannelLayout',
    MANAGE_CHANNEL_LAYOUT = 'ManageChannelLayout',
    MANAGE_CHANNELS = 'ManageChannels',
    DELETE_CHANNELS = 'DeleteChannels',
    VIEW_BRANDS = 'ViewBrands',
    VIEW_BRAND_DETAILS = 'ViewBrandDetails',
    MANAGE_BRAND = 'ManageBrand',
    DELETE_BRAND = 'DeleteBrand',
    VIEW_VENDERS = 'ViewVenders',
    VIEW_VENDER_DETAILS = 'ViewVenderDetails',
    MANAGE_VENDERS = 'ManageVenders',
    DELETE_VENDERS = 'DeleteVenders',
    VIEW_DISABLE_BRANCH_REASONS = 'ViewDisableBranchReasons',
    VIEW_DISABLE_BRANCH_REASON_DETAILS = 'ViewDisableBranchReasonDetails',
    MANAGE_DISABLE_BRANCH_REASONS = 'ManageDisableBranchReasons',
    DELETE_DISABLE_BRANCH_REASONS = 'DeleteDisableBranchReasons',
    VIEW_SALES_MEN = 'ViewSalesMen',
    VIEW_SALES_MAN_DETAILS = 'ViewSalesManDetails',
    MANAGE_SALES_MEN = 'ManageSalesMen',
    DELETE_SALES_MEN = 'DeleteSalesMen',
    VIEW_COUPONS = 'ViewCoupons',
    VIEW_COUPON_DETAILS = 'ViewCouponDetails',
    MANAGE_COUPONS = 'ManageCoupons',
    DELETE_COUPONS = 'DeleteCoupons',
    VIEW_CAMPAIGNS = 'ViewCampaigns',
    VIEW_CAMPAIGN_DETAILS = 'ViewCampaignDetails',
    MANAGE_CAMPAIGN = 'ManageCampaign',
    DELETE_CAMPAIGN = 'DeleteCampaign',
    VIEW_DISCOUNTS = 'ViewDiscounts',
    VIEW_DISCOUNT_DETAILS = 'ViewDiscountDetails',
    MANAGE_DISCOUNTS = 'ManageDiscounts',
    DELETE_DISCOUNTS = 'DeleteDiscounts',
    VIEW_CARDS = 'ViewCards',
    VIEW_CARD_DETAILS = 'ViewCardDetails',
    MANAGE_CARDS = 'ManageCards',
    DELETE_CARDS = 'DeleteCards',
    VIEW_SHOWCASES = 'ViewShowcases',
    VIEW_SHOWCASE_DETAILS = 'ViewShowcaseDetails',
    MANAGE_SHOWCASES = 'ManageShowcases',
    DELETE_SHOWCASES = 'DeleteShowcases',
    VIEW_PRIZES = 'ViewPrizes',
    VIEW_PRIZE_DETAILS = 'ViewPrizeDetails',
    MANAGE_PRIZES = 'ManagePrizes',
    DELETE_PRIZES = 'DeletePrizes',
    VIEW_SPIN_WHEELS = 'ViewSpinWheels',
    VIEW_SPIN_WHEEL_DETAILS = 'ViewSpinWheelDetails',
    MANAGE_SPIN_WHEEL = 'ManageSpinWheel',
    DELETE_SPIN_WHEEL = 'DeleteSpinWheel',
    VIEW_CUSTOM_MESSAGES = 'ViewCustomMessages',
    VIEW_CUSTOM_MESSAGE_DETAILS = 'ViewCustomMessageDetails',
    MANAGE_CUSTOM_MESSAGE = 'ManageCustomMessage',
    DELETE_CUSTOM_MESSAGE = 'DeleteCustomMessage',
    VIEW_DRIVER_TEAMS = 'ViewDriverTeams',
    VIEW_DRIVER_TEAM_DETAILS = 'ViewDriverTeamDetails',
    MANAGE_DRIVER_TEAMS = 'ManageDriverTeams',
    DELETE_DRIVER_TEAMS = 'DeleteDriverTeams',
    VIEW_AVAILABLE_DRIVERS = 'ViewAvailableDrivers',
    VIEW_DRIVER_SALARIES = 'ViewDriverSalaries',
    MANAGE_DRIVERS_SALARIES = 'ManageDriversSalaries',
    VIEW_DRIVER_PERFORMANCE = 'ViewDriverPerformance',
    VIEW_DRIVER_SHIFTS = 'ViewDriverShifts',
    MANAGE_DRIVER_SHIFTS = 'ManageDriverShifts',
    RELEASE_DRIVER_SHIFTS = 'ReleaseDriverShifts',
    VIEW_DRIVER_DOCUMENTS = 'ViewDriverDocuments',
    MANAGE_DRIVER_DOCUMENTS = 'ManageDriverDocuments',
    VIEW_DRIVER_SESSIONS = 'ViewDriverSessions',
    VIEW_DRIVER_EARNING = 'ViewDriverEarning',
    VIEW_DRIVERS = 'ViewDrivers',
    MANAGE_DRIVERS = 'ManageDrivers',
    DELETE_DRIVERS = 'DeleteDrivers',
    MANAGE_DRIVER_REGISTRATIONS = 'ManageDriverRegistrations',
    VIEW_DRIVER_REGISTRATIONS = 'ViewDriverRegistrations',
    MANAGE_DRIVER_BLOCKS = 'ManageDriverBlocks',
    VIEW_DRIVER_BLOCKS = 'ViewDriverBlocks',
    MANAGE_VEHICLES = 'ManageVehicles',
    VIEW_VEHICLES = 'ViewVehicles',
    DELETE_VEHICLES = 'DeleteVehicles',
    VIEW_DRIVER_HALTS = 'ViewDriverHalts',
    MANAGE_DRIVER_HALTS = 'ManageDriverHalts',
    VIEW_DRIVER_POUCHES = 'ViewDriverPouches',
    MANAGE_DRIVER_POUCHES = 'ManageDriverPouches',
    VIEW_ACCOUNTANT_POUCHES = 'ViewAccountantPouches',
    VIEW_DRIVER_POUCH_OPERATIONS = 'ViewDriverPouchOperations',
    VIEW_ACCOUNTANT_POUCH_OPERATIONS = 'ViewAccountantPouchOperations',
    WITHDRAWAL_ACCOUNTANT_POUCH = 'WithdrawalAccountantPouch',
    WITHDRAWAL_DRIVER_POUCH = 'WithdrawalDriverPouch',
    VIEW_SHIFT_TEMPLATES = 'ViewShiftTemplates',
    VIEW_SHIFT_TEMPLATE_DETAILS = 'ViewShiftTemplateDetails',
    MANAGE_SHIFT_TEMPLATES = 'ManageShiftTemplates',
    ACTIVATE_SHIFT_TEMPLATES = 'ActivateShiftTemplates',
    DELETE_SHIFT_TEMPLATES = 'DeleteShiftTemplates',
    VIEW_SALARY_SYSTEMS = 'ViewSalarySystems',
    VIEW_SALARY_SYSTEM_DETAILS = 'ViewSalarySystemDetails',
    MANAGE_SALARY_SYSTEM = 'ManageSalarySystem',
    DELETE_SALARY_SYSTEM = 'DeleteSalarySystem',
    VIEW_SHIFT_SETTINGS = 'ViewShiftSettings',
    MANAGE_SHIFT_SETTINGS = 'ManageShiftSettings',
    VIEW_USERS = 'ViewUsers',
    MANAGE_USERS = 'ManageUsers',
    VIEW_USER_ADDRESS = 'ViewUserAddress',
    MANAGE_USER_ADDRESS = 'ManageUserAddress',
    MANAGE_USER_VIP = 'ManageUserVip',
    VIEW_USER_ROLES = 'ViewUserRoles',
    MANAGE_USER_ROLES = 'ManageUserRoles',
    VIEW_ROLES = 'ViewRoles',
    MANAGE_ROLES = 'ManageRoles',
    DELETE_ROLES = 'DeleteRoles',
    VIEW_BASE_ROLES = 'ViewBaseRoles',
    MANAGE_BASE_ROLES = 'ManageBaseRoles',
    VIEW_SERVICES = 'ViewServices',
    MANAGE_SERVICES = 'ManageServices',
    DELETE_SERVICES = 'DeleteServices',
    VIEW_DISTRICTS = 'ViewDistricts',
    MANAGE_DISTRICTS = 'ManageDistricts',
    DELETE_DISTRICTS = 'DeleteDistricts',
    MANAGE_TRANSLATIONS = 'ManageTranslations',
    VIEW_TRANSLATIONS = 'ViewTranslations',
    MANAGE_PANEL_SETTINGS = 'ManagePanelSettings',
    VIEW_PANEL_SETTINGS = 'ViewPanelSettings',
    VIEW_POLICIES = 'ViewPolicies',
    VIEW_SERVICE_STATISTICS = 'ViewServiceStatistics',
    SYNC_ALGOLIA_BRANCHES = 'SyncAlgoliaBranches',
    SYNC_ALGOLIA_ITEMS = 'SyncAlgoliaItems',
    VIEW_CHANNEL_USERS = 'ViewChannelUsers',
    MANAGE_CHANNEL_USERS = 'ManageChannelUsers',
    DELETE_CHANNEL_USERS = 'DeleteChannelUsers',
    VIEW_ACTIVITY_LOGS = 'ViewActivityLogs',
    VIEW_ESTIMATED_DELIVERY = 'ViewEstimatedDelivery',
    MANAGE_ESTIMATED_DELIVERY = 'ManageEstimatedDelivery',
    MANAGE_SEARCH_SETTINGS = 'ManageSearchSettings',
    VIEW_SEARCH_SETTINGS = 'ViewSearchSettings',
    VIEW_BRANCH_DELIVERY_SYSTEMS = 'ViewBranchDeliverySystems',
    MANAGE_BRANCH_DELIVERY_SYSTEMS = 'ManageBranchDeliverySystems',
    DELETE_BRANCH_DELIVERY_SYSTEMS = 'DeleteBranchDeliverySystems',
    VIEW_CANCELED_ORDERS = 'ViewCanceledOrders',
    VIEW_BRANCH_TAGS = 'ViewBranchTags',
    VIEW_BRANCH_TAG_BRANCHES = 'ViewBranchTagBranches',
    MANAGE_BRANCH_TAGS = 'ManageBranchTags',
    DELETE_BRANCH_TAGS = 'DeleteBranchTags',
    START_ORDER_SEARCH = 'StartOrderSearch',
    FINISH_ORDER_SEARCH = 'FinishOrderSearch',
    VIEW_ORDER_PAYMENT_TYPES = 'ViewOrderPaymentTypes',
    MANAGE_ORDER_PAYMENT_TYPES = 'ManageOrderPaymentTypes',
    VIEW_SUPPORT_MESSAGES = 'ViewSupportMessages',
    MANAGE_SUPPORT_MESSAGE = 'ManageSupportMessage',
    DELETE_SUPPORT_MESSAGE = 'DeleteSupportMessage',
    UNASSIGN_ORDER_FROM_DRIVER = 'UnassignOrderFromDriver',
    MANAGE_SHIFTS = 'ManageShifts',
    VIEW_SHIFTS = 'ViewShifts',
    DELETE_SHIFTS = 'DeleteShifts',
    WATCH_ORDERS = 'WatchOrders',
    VIEW_ONLINE_PAYMENTS = 'ViewOnlinePayments',
    VIEW_ONLINE_PAYMENT_DETAILS = 'ViewOnlinePaymentDetails',
    MANAGE_ONLINE_PAYMENTS = 'ManageOnlinePayments',
    EXPORT_DRIVER_POUCH_FILES = 'ExportDriverPouchFiles',
    EXPORT_ACCOUNTANT_POUCH_FILES = 'ExportAccountantPouchFiles',
    MANAGE_USER_ORDER_RATES = 'ManageUserOrderRates',
    VIEW_ORDER_STATISTICS = 'ViewOrderStatistics',
    VIEW_COMPANIES = 'ViewCompanies',
    MANAGE_COMPANIES = 'ManageCompanies',
    VIEW_MEAL_TIERS = 'ViewMealTiers',
    MANAGE_MEAL_TIERS = 'ManageMealTiers',
    VIEW_SUBSCRIPTIONS = 'ViewSubscriptions',
    MANAGE_SUBSCRIPTIONS = 'ManageSubscriptions',
    VIEW_COMPANY_USERS = 'ViewCompanyUsers',
    MANAGE_COMPANY_USERS = 'ManageCompanyUsers',
    VIEW_MEAL_ITEMS = 'ViewMealItems',
    MANAGE_MEAL_ITEMS = 'ManageMealItems',
    MANAGE_MEALS = 'ManageMeals',
    VIEW_COMPANY_BRANCHES = 'ViewCompanyBranches',
    MANAGE_COMPANY_BRANCHES = 'ManageCompanyBranches',
    MANAGE_BRANCH_MEAL_COMMISSION_AMOUNT = 'ManageBranchMealCommissionAmount',
    VIEW_ADJUSTMENTS = 'ViewAdjustments',
    VIEW_ADJUSTMENT_DETAILS = 'ViewAdjustmentDetails',
    MANAGE_ADJUSTMENTS = 'ManageAdjustments',
    DELETE_ADJUSTMENTS = 'DeleteAdjustments',
    VIEW_PARTNERS = 'ViewPartners',
    VIEW_PARTNER_DETAILS = 'ViewPartnerDetails',
    MANAGE_PARTNERS = 'ManagePartners',
    DELETE_PARTNERS = 'DeletePartners',
    VIEW_CANCEL_DELIVERY_REASONS = 'ViewCancelDeliveryReasons',
    MANAGE_CANCEL_DELIVERY_REASONS = 'ManageCancelDeliveryReasons',
    DELETE_CANCEL_DELIVERY_REASONS = 'DeleteCancelDeliveryReasons',
    MANAGE_LOYALTY_PROGRAM_SETTINGS = 'ManageLoyaltyProgramSettings',
    VIEW_LOYALTY_PROGRAM_SETTINGS = 'ViewLoyaltyProgramSettings',
    MANAGE_LOYALTY_PROGRAM_TIERS = 'ManageLoyaltyProgramTiers',
    VIEW_LOYALTY_PROGRAM_TIERS = 'ViewLoyaltyProgramTiers',
    DELETE_LOYALTY_PROGRAM_TIERS = 'DeleteLoyaltyProgramTiers',
    MANAGE_REGION_DELIVERY_RANGE_SETTINGS = 'ManageRegionDeliveryRangeSettings',
    VIEW_REGION_DELIVERY_RANGE_SETTINGS = 'ViewRegionDeliveryRangeSettings',
    APPROVE_ORDER_WITH_DEFAULT_REGION_ADDRESS = 'ApproveOrderWithDefaultRegionAddress',
    VIEW_PACKAGES = 'ViewPackages',
    VIEW_PACKAGE_DETAILS = 'ViewPackageDetails',
    MANAGE_PACKAGES = 'ManagePackages',
    MANAGE_REMINDER_SETTINGS = 'ManageReminderSettings',
    VIEW_REMINDER_SETTINGS = 'ViewReminderSettings',
    VIEW_STREAMING_PACKAGES = 'ViewStreamingPackages',
    CREATE_SYNC_EXTERNAL_BRANCH_JOBS = 'CreateSyncExternalBranchJobs',
    VIEW_SYNC_EXTERNAL_BRANCH_JOBS = 'ViewSyncExternalBranchJobs',
    CANCEL_SYNC_EXTERNAL_BRANCH_JOBS = 'CancelSyncExternalBranchJobs',
    WATCH_MEALS = 'WatchMeals',
    WATCH_PACKAGES = 'WatchPackages',
    VIEW_DRIVER_DETAIL = 'ViewDriverDetail',
    VIEW_MEAL_CATEGORIES = 'ViewMealCategories',
    VIEW_MEAL_CATEGORY_DETAILS = 'ViewMealCategoryDetails',
    MANAGE_MEAL_CATEGORIES = 'ManageMealCategories',
    DELETE_MEAL_CATEGORIES = 'DeleteMealCategories',
    VIEW_TRENDING_SEARCHES = 'ViewTrendingSearches',
    VIEW_TRENDING_SEARCH_DETAILS = 'ViewTrendingSearchDetails',
    MANAGE_TRENDING_SEARCH = 'ManageTrendingSearch',
    DELETE_TRENDING_SEARCH = 'DeleteTrendingSearch',
    MANAGE_ORDER_COMPENSATION = 'ManageOrderCompensation',
    VIEW_BRANCH_PINS = 'ViewBranchPins',
    MANAGE_BRANCH_PINS = 'ManageBranchPins',
    DELETE_BRANCH_PINS = 'DeleteBranchPins',
    MANAGE_ADJUSTMENT_REASONS = 'ManageAdjustmentReasons',
    VIEW_ADJUSTMENT_REASONS = 'ViewAdjustmentReasons',
    MANAGE_REGION_ZONES = 'ManageRegionZones',
    VIEW_CASHBACK_OFFERS = 'ViewCashbackOffers',
    VIEW_CASHBACK_OFFER_DETAILS = 'ViewCashbackOfferDetails',
    MANAGE_CASHBACK_OFFERS = 'ManageCashbackOffers',
    DELETE_CASHBACK_OFFERS = 'DeleteCashbackOffers',
    VIEW_DRIVER_BREAKS = 'ViewDriverBreaks',
    MANAGE_DRIVER_BREAKS = 'ManageDriverBreaks',
    VIEW_DRIVER_DAY_OFFS = 'ViewDriverDayOffs',
    MANAGE_DRIVER_DAY_OFFS = 'ManageDriverDayOffs',
    VIEW_DRIVER_PENALTIES = 'ViewDriverPenalties',
    MANAGE_DRIVER_PENALTIES = 'ManageDriverPenalties',
    VIEW_OPERATOR_PRICE_CHANGES = 'ViewOperatorPriceChanges',
    VIEW_BRANCH_MINIMUM_CART_SYSTEMS = 'ViewBranchMinimumCartSystems',
    MANAGE_BRANCH_MINIMUM_CART_SYSTEMS = 'ManageBranchMinimumCartSystems',
    DELETE_BRANCH_MINIMUM_CART_SYSTEMS = 'DeleteBranchMinimumCartSystems',
    VIEW_DRIVER_RANK_SETTINGS = 'ViewDriverRankSettings',
    MANAGE_DRIVER_RANK_SETTINGS = 'ManageDriverRankSettings',
    VIEW_DRIVER_RANK_TIER_CONFIGS = 'ViewDriverRankTierConfigs',
    MANAGE_DRIVER_RANK_TIER_CONFIGS = 'ManageDriverRankTierConfigs',
    DELETE_DRIVER_RANK_TIER_CONFIGS = 'DeleteDriverRankTierConfigs',
    VIEW_DRIVER_RANKINGS = 'ViewDriverRankings',
    VIEW_DRIVER_DAILY_METRICS = 'ViewDriverDailyMetrics',
    RUN_DRIVER_RANKINGS_MANUALLY = 'RunDriverRankingsManually',
    RUN_DRIVER_DAILY_METRICS_MANUALLY = 'RunDriverDailyMetricsManually',
    BYPASS_ORDER_MANUAL_ASSIGN_ACQUIRE_CHECKS = 'BypassOrderManualAssignAcquireChecks',
    VIEW_MENU_SCREENS = 'ViewMenuScreens',
    MANAGE_MENU_SCREENS = 'ManageMenuScreens',
    VIEW_CHANNEL_WORKING_HOURS = 'ViewChannelWorkingHours',
    MANAGE_CHANNEL_WORKING_HOURS = 'ManageChannelWorkingHours',
    VIEW_DRIVER_SHIFT_ADHERENCE = 'ViewDriverShiftAdherence',
    VIEW_DRIVER_ACCEPTANCE_RATE = 'ViewDriverAcceptanceRate',
    VIEW_DRIVER_METRIC_ADJUSTMENTS = 'ViewDriverMetricAdjustments',
    MANAGE_DRIVER_METRIC_ADJUSTMENTS = 'ManageDriverMetricAdjustments',
    VIEW_DRIVER_CURRENT_ORDERS = 'ViewDriverCurrentOrders',
    BYPASS_ORDER_LIST2HOURS_RESTRICTION = 'BypassOrderList2HoursRestriction',
    BYPASS_PACKAGE_LIST2HOURS_RESTRICTION = 'BypassPackageList2HoursRestriction',
    BYPASS_MEAL_LIST2HOURS_RESTRICTION = 'BypassMealList2HoursRestriction',
    BYPASS_ORDER_LIST7DAYS_RESTRICTION = 'BypassOrderList7DaysRestriction',
    BYPASS_PACKAGE_LIST7DAYS_RESTRICTION = 'BypassPackageList7DaysRestriction',
    BYPASS_MEAL_LIST7DAYS_RESTRICTION = 'BypassMealList7DaysRestriction',
}
